import { Mappable } from './mappable';

export class UsState extends Mappable {
  code: string;
  name: string;

  constructor() { super() }
}